import { Component, OnInit, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { DashboardService } from "../../../../../services/dashboard.service";
import { SharedService } from "../../../../../services/shared.service";
import { BloccoModel } from "../../../../../models/dashboard/blocco.model";
import { DriverModel } from "../../../../../models/dashboard/driver.model";

@Component({
  selector: "app-download-external-form",
  templateUrl: "./download-external-form.component.html",
  styleUrls: ["./download-external-form.component.css"],
})
export class DownloadExternalFormComponent implements OnInit {
  @Input("form") form: FormGroup;

  blocco: BloccoModel;
  requests: Array<any> = [];
  drivers: Array<any> = [];
  driversTipo: Array<any> = [];

  driverTipo: number = 1;

  driver: DriverModel;

  constructor(
    private _dashboardService: DashboardService,
    private _sharedService: SharedService
  ) {}

  ngOnInit() {
    this.blocco = this._sharedService.getBlocco();
    this._dashboardService
      .getBlocchiDownloadExternalSourceDriver()
      .subscribe((response) => {
        this.drivers = response;
        if (
          this.blocco &&
          this.blocco.externalSourceDriver &&
          this.blocco.externalSourceDriver.id
        ) {
          this.driver = this.drivers.find(
            (driver) => driver.id === this.blocco.externalSourceDriver.id
          );
          this.form
            .get("idBloccoDownloadExternalSourceDriver")
            .setValue(this.blocco.externalSourceDriver.id);
          this._sharedService.setDriver(this.driver);
        } else {
          this.driver = this.drivers.find(
            (driver) =>
              driver.routeAnagrafica.nome ===
              "BloccoDownloadExternalSourceItemTaxonomy"
          );
          this.form
            .get("idBloccoDownloadExternalSourceDriver")
            .setValue(this.driver.id);
        }
      });
    this._dashboardService
      .getBlocchiDownloadExternalSourceDriverTipo()
      .subscribe((res) => {
        this.driversTipo = res;
      });

    this.form.controls["idBloccoDownloadExternalSourceDriverTipo"].disable();
  }

  onChangeDriverTipo(event) {
    console.log(event);
  }

  onChangeDriver(event) {
    this._sharedService.setDriver(
      this.drivers.find((driver) => driver.id === event.value)
    );
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/forms/download-external/download-external-form.component.ts